import { DownloadpdfComponent } from './../downloadpdf/downloadpdf.component';
import { ExistinguserdialogComponent } from './../existinguserdialog/existinguserdialog.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Component } from '@angular/core';

@Component({
  selector: 'app-olduser',
  templateUrl: './olduser.component.html',
  styleUrls: ['./olduser.component.css']
})
export class OlduserComponent {

  constructor(public dialog: MatDialog,  public dialogRef: MatDialogRef<OlduserComponent>) { }

  close(): void {
    this.dialogRef.close(null);
  }

  existuser() {
    const dialogRef = this.dialog.open(ExistinguserdialogComponent, {
      disableClose: true,
      // width: '600px',
      // height: '400px'

    });
    this.close();
  }

  downloadpdf() {
    const dialogRef = this.dialog.open(DownloadpdfComponent, {
      disableClose: true,
    
    });
    this.close();
  }

}
